import color from "../../constants/color";

const style = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: 3.5,
  },
  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
    mb: 2
  },
  btnGridAction: {
    width: "100%",
    ml: { xs: 1, md: 0 },
  },
  medicalRadioSection: {
    display: "flex",
    mt: { xs: 2, md: 0 }
  },
  gridContainer: {
    alignItems: "center",
    justifyContent: "space-between"
  },
  endTime: {
    ml: 2
  },
  radioGrid: {
    display: "flex",
  },
  btnGrid: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    mx: 1
  },
  submitButton: {
    borderRadius: 50,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: color.primary,
    "& .MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: 1
  },
  reason: {
    borderRadius: "18px",
    width: "100%",
    "& .MuiInputBase-input": {
      py: 1
    },
  },
  formGrid: {
    display: "flex"
  },
  dateInput: {
    width: "100%",
    my: 1,
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },
  jobButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "12px",
    mt: 1,
  },
  inputSection: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "space-between",
  },
  inputCreditSection: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: 'row',
    mb: 1.5,
    width: "100%"
  },
  calenderInput: {
    "& .MuiInputBase-input": {
      padding: "7.5px 14px",
    },
    width: "100%",
  },
  inputCreditSections: {
    display: { xs: "block", md: "flex" },
    px: 2,
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: 'row',
    mb: 1.5,
    width: "100%"
  },
  inlineBlock: {
    display: "block",
    width: "100%",
    px: 2,
    mb: 1.5,
  },
  inputLabel: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    textAlign: "center"
  },
  deleteIcon: {
    p: 1,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  inputContainerBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  },
  modalInput: {
    my: "6px",
    fontSize: "14px",
    width: "100%",
    "& .MuiInputBase-input": {
      padding: "8px 14px",
      height: "auto"
    },
    "& .MuiOutlinedInput-root": {
      padding: "0",
      width: "100%"
    },
  },
  creditmodalInput: {
    display: "flex",
    justifyContent: "center",
    my: "10px",
    height: "2.4em",
    fontSize: "14px",
    "& .MuiInputBase-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    },
  },
  inputItems: {
    width: 'auto',
  },
  selectGrid: {
    mr: 1,
  },
  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },
    "& .MuiBox-root": {
      py: "7px"
    }
  },
  leaveInputGrid: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "space-between"
  },
  leaveSheetGrid: {
    display: { xs: "block", md: "flex" },
    ml: { xs: 0, md: 2 },
    mt: { xs: 0, md: 2 },
    height: "fit-content"
  },
  leaveSheet: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "5px",
    px: 1,
    mr: 1,
    mb: { xs: 1, md: 0 },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& > div": {
      display: "flex",
    },
  },
  closeIcon: {
    fontSize: "1rem",
    ml: 2,
  },
  inputBox: {
    width: "25%",
  },
  inputCreditBox: {
    minWidth: "20%"
  },
  inputText: {
    fontSize: "14px",
    fontWeight: "600",
    color: color.text,
  },
  inputTextr: {
    fontSize: "18px",
    fontWeight: "600",
    color: color.text,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  inputCreditTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: color.text,
  },
  gridboxTime: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px: 2,
    borderRadius: "20px",
  },
  weakGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 1
  },
  formControlLabel: {
    display: "block",
  },
  greyLine: {
    border: "1px solid #DEDEDE",
    width: "75%",
  },
  edit: {
    backgroundColor: "#A3E1FB",
    borderRadius: "8px",
    mx: 1,
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",
  },
  delete: {
    backgroundColor: color.lightRed,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",
  },
  gridboxs: {
    backgroundColor: "#ffff",
    mt: 0,
    mx: 2,
    mb: 2,
    py: 4,
    borderRadius: "20px",
    height: "fit-content",
  },
  itemSection: {
    display: "flex",
    mx: 2,
    alignItems: "center",
    width: "100%",
  },
  gridText: {
    fontSize: "14px",
    fontWeight: "600"
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display: "flex",
    flexDirection: "row",
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    pr: 2,
    display: "flex",
    justifyContent: "end",
    my: 2
  },
  mainContainers: {
    justifyContent: "end",
  },
  mainContainerPension: {
    justifyContent: "end",
    mb: 3
  },
  dropdown: {
    "& .MuiSelect-select": {
      padding: "8.5px 14px",
    },
    width: "100%",
    fontSize: "14px",
    fontWeight: "400",
    mt: 1,
  },
  typeGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: "15px",
  },
  popupBox: {
    width: "100%",
  },
  contributionsInput: {
    width: "100%"
  },
  mainContainer: {},
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px: 1,
    borderRadius: "20px",
    height: "fit-content",
    display: "flex",
    flexWrap: "wrap",
  },
  tableSectionWrapper: {
    width: "100%",
    px: 2,
  },
  tableCard: {
    border: "1px solid #E6E6E6",
    borderRadius: "10px",
    overflow: "hidden",
    width: "100%",
  },
  tableHeader: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#FAFAFA",
    borderBottom: "1px solid #E6E6E6",
    height: "54px",
    px: 2,
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
    minHeight: "72px",
    px: 2,
    borderBottom: "1px solid #F0F0F0",
  },
  thType: {
    flex: "1 1 25%",
    fontWeight: 600,
    fontSize: "14px",
    px: 2,
    color: "#000000",
    display: "flex",
    alignItems: "center"
  },
  thMode: {
    flex: "1 1 35%",
    fontWeight: 600,
    fontSize: "14px",
    px: 2,
    color: "#000000",
    display: "flex",
    alignItems: "center"
  },
  thValue: {
    flex: "1 1 25%",
    fontWeight: 600,
    fontSize: "14px",
    px: 2,
    color: "#000000",
    display: "flex",
    alignItems: "center"
  },
  tdType: {
    flex: "1 1 25%",
    fontSize: "14px",
    px: 2,
    color: "#000000",
    display: "flex",
    alignItems: "center"
  },
  tdMode: {
    flex: "1 1 35%",
    px: 2,
    color: "#000000",
    display: "flex",
    alignItems: "center"
  },
  tdValue: {
    flex: "1 1 25%",
    px: 2,
    color: "#000000",
    display: "flex",
    alignItems: "center"
  },
  valueInput: { width: "100%", minWidth: "150px" },
  rateHeading: { fontWeight: 500, fontSize: "16px", mt: 2 },
  modalGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    mb: 1,
    gap: "16px",
  },
  inputTexts: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  heading: {
    width: { xs: "30%", md: "20%", lg: "20%" },
  },
  head: {
    fontSize: "20px",
    fontWeight: "700",
    color: color.text,
    mt: 1,
    whiteSpace: "nowrap",
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    px: 3,
    mr: 1,
  },
  dropDownMenu: {
    fontWeight: 400,
    fontSize: "12px",
  },
  headerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 2,
    mt: 3,
    ml: 3,
    mr: 2
  },
  fyFrequencyBox: {
    px: 2,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 2
  },
  selectFY: {
    display: "flex",
    justifyContent: "center",
    my: "10px",
    height: "2.4em",
    fontSize: "14px",
    "& .MuiInputBase-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0",
      height: "40px"
    },
    width: "300px",
  },
  selectFrequency: {
    display: "flex",
    justifyContent: "center",
    my: "10px",
    height: "2.4em",
    fontSize: "14px",
    "& .MuiInputBase-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0",
      height: "40px"
    },
    width: "300px",
  },
  errorText: {
    color: 'red',
    fontSize: 12,
    ml: 2
  },
  tableHeaderCell: {
    flex: 2,
    fontWeight: 600,
    fontSize: "14px"
  },
  tableHeaderCellCenter: {
    flex: 2,
    fontWeight: 600,
    fontSize: "14px",
    textAlign: "center"
  },
  tableHeaderCellDelete: {
    flex: 1,
    fontWeight: 600,
    fontSize: "14px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  tableCell: {
    flex: 2,
    fontSize: "14px"
  },
  tableCellBeneficiaries: {
    flex: 2,
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end", gap: 1
  },
  tableCellDelete: {
    flex: 1,
    fontSize: "14px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "80px"
  },
  textFieldSmall: {
    width: "220px",
    minWidth: "220px",
    maxWidth: "220px",
    "& .MuiInputBase-root": {
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
      fontSize: "14px",
      width: "220px",
      minWidth: "220px",
      maxWidth: "220px"
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 14px"
    }
  },
  selectSmall: {
    width: "220px",
    minWidth: "220px",
    maxWidth: "220px",
    height: "40px",
    minHeight: "40px",
    maxHeight: "40px",
    "& .MuiOutlinedInput-root": {
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
      fontSize: "14px",
      width: "220px"
    },
    "& .MuiSelect-select": {
      height: "40px",
      minHeight: "40px",
      fontSize: "14px",
      padding: "8px 14px",
      display: "flex",
      alignItems: "center"
    }
  },
  saveButton: {
    borderRadius: 50,
    textTransform: "none",
    fontSize: "12px",
    px: 2,
    height: "32px",
    "&:disabled": {
      backgroundColor: "#ccc",
    }
  },
  deleteIconButton: {
    backgroundColor: color.lightRed,
    borderRadius: "8px",
    width: "27px",
    height: "27px",
    padding: "4px",
    "&:hover": {
      backgroundColor: "#F8A5A5",
    }
  },
  beneficiaryIconButton: {
    backgroundColor: "#007bff",
    borderRadius: "8px",
    width: "27px",
    height: "27px",
    padding: "4px",
    "&:hover": {
      backgroundColor: "#007bff",
    }
  },
  beneficiaryIcon: {
    fontSize: "16px",
    color: "#ffffff"
  },
  deleteIconStyle: {
    fontSize: "16px",
    color: "#ff0000"
  },
  emptyText: {
    fontSize: "14px",
    color: "#999"
  },
  emptyRow: {
    flex: 1,
    fontSize: "14px",
    textAlign: "center",
    width: "100%",
    py: 2
  },
  addNewCreditBox: {
    display: "flex",
    justifyContent: "flex-start",
    mb: 2,
    px: 2,
    mt: 2
  },
  addNewCreditButton: {
    borderRadius: 50,
    textTransform: "none",
    fontSize: "14px",
    px: 3,
    height: "40px",
  },
  addBeneficiaryButton: {
    borderRadius: 50,
    textTransform: "none",
    fontSize: "14px",
    fontWeight: "500",
  },
  addBeneficiaryBox: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 2,
    px: { xs: 1, sm: 2 },
    width: "100%"
  },
  inputBoxs: {
    display: "flex",
    flexDirection: "column",
    gap: 1
  },
  tableCellActions: {
    flex: 1,
    fontSize: "14px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    minWidth: "80px"
  },
  tableCellEmpty: {
    flex: 0.5
  },
  tableCellDeleteAction: {
    flex: "0 0 60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "60px"
  },
  placeholderText: {
    color: "#999"
  },
  selectPlaceholder: {
    color: "#aaa"
  }
};

export default style;
